import React, { useState, useEffect } from 'react';
import { Select, Input, Checkbox, Form, Spin } from 'antd';
import { Link, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { DepositAmountApi, GetPaymentGatewayByIdApi, GetWalletApi } from '../../../api/request/client.js';
import LoadableButton from '../../../components/buttons/LoadableButton.jsx';
import ZaroPayQR from './ZaroPayQR.jsx';

export default function DepositUSDT() {

    const [form] = Form.useForm();
    const params = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [initialValues, setInitialValues] = useState({ amount: '', currency: null, conditions: false });
    const [wallet, setWallet] = useState({});
    const [paymentGateway, setPaymentGateway] = useState({});
    const [isWalletLoading, setIsWalletLoading] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [depositdata, setDepositdata] = useState({});

    const getWallet = async () => {
        try {
            setIsWalletLoading(true);
            let ruleId = {
                RuleType: 3
            }
            const { data } = await GetWalletApi(params?.id, new URLSearchParams(ruleId).toString());
            if (data?.success) {
                setWallet(data?.data)
            }
            setIsWalletLoading(false);
        } catch (error) {
            setIsWalletLoading(false);
        }
    }

    const getPaymentGateway = async () => {
        try {
            setIsWalletLoading(true);
            const { data } = await GetPaymentGatewayByIdApi(params?.paymentId);
            if (data?.success) {
                setPaymentGateway(data?.data);
            }
            setIsWalletLoading(false);
        } catch (error) {
            setIsWalletLoading(false);
        }
    }

    useEffect(() => {
        getWallet();
        getPaymentGateway();
    }, []);

    const handleSubmit = async (values) => {
        try {
            setIsLoading(true);
            const depositParams = {
                userId: params?.id,
                paymentGatwayId: params?.paymentId,
                amount: Number(values?.amount),
            };
            const { data } = await DepositAmountApi(depositParams);
            if (data?.success) {
                form.resetFields();
                setIsOpenModal(true);
                setDepositdata(data?.data);
            }
            setIsLoading(false);
        } catch (error) {
            if (error?.response?.data?.message) {
                toast.error(error?.response?.data?.message);
            }
            setIsLoading(false);
        }
    }

    return (
        <div>
            <div className='border-[2px] border-light rounded-[20px] w-full'>
                {isWalletLoading ? (
                    <div className="flex justify-center flex-col my-6">
                        <Spin size="large" />
                        <p className="primary text-center mt-2">Loading...</p>
                    </div>
                ) : (
                    <div className='p-4 mb-3 grid sm:grid-cols-3 lg:grid-cols-5 gap-5 lg:divide-x'>
                        <div>
                            <div className='flex justify-center'>
                                <p className='text-base font-normal text-center pb-2'>Transaction fees(%)</p>
                            </div>
                            <p className='text-xl primary font-semibold text-center mt-2'>{paymentGateway?.fees}</p>
                        </div>
                        <div>
                            <div className='flex justify-center'>
                                <p className='text-base font-normal text-center pb-2 '>Processing Time</p>
                            </div>
                            <p className='text-xl primary font-semibold text-center mt-2'>{paymentGateway?.processingTime}</p>
                        </div>
                        <div>
                            <div className='flex justify-center'>
                                <p className='text-base font-normal text-center pb-2 '>Currencies</p>
                            </div>
                            <p className='text-xl primary font-semibold text-center mt-2'>{paymentGateway?.currency}</p>
                        </div>
                        <div>
                            <div className='flex justify-center'>
                                <p className='text-base font-normal text-center pb-2 '>Minimum Deposit</p>
                            </div>
                            <p className='text-xl primary font-semibold text-center mt-2'>$ {wallet?.minAmount || '0'}</p>
                        </div>
                        <div>
                            <div className='flex justify-center'>
                                <p className='text-base font-normal text-center pb-2 '>Maximum Deposit</p>
                            </div>
                            <p className='text-xl primary font-semibold text-center mt-2'>$ {wallet?.maxAmount || '0'}</p>
                        </div>
                    </div>
                )}
            </div>

            <div className='border-[2px] border-light rounded-[20px] pt-4 lg:pt-6 w-full mt-5'>
                <div className='flex items-center border-b border-[#8D5AE233] px-4 lg:px-6 pb-4'>
                    <img src='/assets/icons/zaro-pay.svg' alt='icon' />
                    <p className='text-[#2F2B3D] text-xl font-semibold ml-3'>Zaro Pay</p>
                </div>

                <Form className='w-full lg:p-6 p-4' autoComplete="off" form={form} initialValues={initialValues} onFinish={handleSubmit}>
                    <div className='md:flex md:flex-wrap gap-5'>
                        <div className="md:w-1/3 input-white">
                            <label className='text-lg text-[#2F2B3DCC] font-medium'>Amount In USD</label>
                            <Form.Item name='amount' rules={[{ required: true, message: 'Please enter amount.' }, { validator: (_, value) => Number.isInteger(Number(value)) ? Promise.resolve() : Promise.reject(new Error('Please enter a valid amount.')) }]}>
                                <Input type='number' placeholder="Amount in USD" className="mt-1 w-full ps-4 py-2" />
                            </Form.Item>
                        </div>
                    </div>
                    <Form.Item name='conditions' valuePropName="checked" rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')), }]} >
                        <Checkbox className='mt-4'>Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300' >Terms and conditions</Link></Checkbox>
                    </Form.Item>
                    <div className="md:w-1/4 mt-4">
                        <LoadableButton
                            className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
                            disabled={isLoading}
                            type="Submit"
                            lable='Submit'
                            isLoading={isLoading}
                            loadingLable='Adding request...'
                        />
                    </div>
                </Form>
            </div>

            <ZaroPayQR isOpenModal={isOpenModal} setIsOpenModal={setIsOpenModal} Depositdata={depositdata} />
        </div>
    )
}
